import { Paper, useTheme } from "@material-ui/core";

export default function Banner(props: {
  title: string;
  children: React.ReactChild | React.ReactChild[];
  color?: string;
  icon?: React.ReactChild | React.ReactChild[];
}) {
  const theme = useTheme();
  const color = props.color ?? theme.palette.primary.main;
  return (
    <Paper
      elevation={5}
      style={{
        backgroundColor: color,
        padding: theme.spacing(3),
        color: "white",
      }}
    >
      {props.children}
    </Paper>
  );
}
